<!-- A generic confirm/cancel dialog which executes a function that's passed as a prop -->

<template>
  <v-dialog max-width="600" v-model="visible" persistent style="z-index: 3">
    <v-card>
      <!-- Title -->
      <v-card-title>{{ title }}</v-card-title>

      <!-- Message -->
      <v-card-text
        v-html="message"
        style="max-height: 60vh; overflow-y: auto"
      />

      <v-card-actions class="pb-3">
        <!-- Neutral button -->
        <v-btn
          :class="showNeutralBtn ? '' : 'd-none'"
          class="text-capitalize"
          color="secondary"
          @click="onNeutralBtnClick"
        >
          {{ neutralBtnText }}
        </v-btn>

        <v-spacer></v-spacer>

        <!-- Negative button -->
        <v-btn
          :class="showNegativeBtn ? '' : 'd-none'"
          class="text-capitalize"
          color="secondary"
          @click="onNegativeBtnClick"
        >
          {{ negativeBtnText }}
        </v-btn>

        <!-- Positive button -->
        <v-btn
          :class="showPositiveBtn ? '' : 'd-none'"
          class="text-capitalize primary-font-color"
          color="primary"
          @click="onPositiveBtnClick"
        >
          {{ positiveBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: String,
    message: String,
    neutralBtnText: String,
    positiveBtnText: String,
    negativeBtnText: String,
  },
  data() {
    return {};
  },
  computed: {
    showNeutralBtn() {
      if (this.neutralBtnText != null && this.neutralBtnText !== '') {
        return true;
      }
      return false;
    },
    showNegativeBtn() {
      if (this.negativeBtnText != null && this.negativeBtnText !== '') {
        return true;
      }
      return false;
    },
    showPositiveBtn() {
      if (this.positiveBtnText != null && this.positiveBtnText !== '') {
        return true;
      }
      return false;
    },
  },
  methods: {
    onNeutralBtnClick() {
      this.$emit('neutralBtnClicked');
    },
    onNegativeBtnClick() {
      this.$emit('negativeBtnClicked');
    },
    onPositiveBtnClick() {
      this.$emit('positiveBtnClicked');
    },
  },
};
</script>
